<template>
  <span class="checkbox-container">
    <input type="checkbox" :id="id" class="checkbox" :class="{invalid: invalid}"
           v-bind:value="value"
           v-on:click="$emit('input', $event.target.checked)"/>
    <span class="checkbox-symbol"></span>
    <label :for="id" class="label" :class="{invalid: invalid}"><slot/></label>
  </span>
</template>

<script>
export default {
  name: "Checkbox",
  computed: {
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    value: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },

  }
}
</script>

<style lang="scss" scoped>

.checkbox-container {
  position: relative;
  display: inline-block;


  .checkbox {
    opacity: 0;
    cursor: pointer;

    &.invalid + span {
      border-color: $error;
    }

    &:checked + span {
      background-color: #3737e6;
      border-color: #3737e6;
    }
  }


  .checkbox-symbol {
    display: block;
    position: absolute;
    top: 4px;
    //transform: translateY(-50%);
    left: 0;
    content: "";
    display: block;
    width: 14px;
    height: 14px;
    border: 1px solid #3737e6;
    pointer-events: none;
  }


  .label {
    //font-size: $font-size-b2;
    text-transform: none;
    margin-left: 0.75em;
    color: #1F2429;
    &.invalid {
      color: $error;
    }
  }

}


</style>